var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFriendsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 12.0001C9.52125 12.0001 11.4 10.1213 11.4 7.8001C11.4 5.47885 9.52125 3.6001 7.2 3.6001C4.87875 3.6001 3 5.47885 3 7.8001C3 10.1213 4.87875 12.0001 7.2 12.0001ZM10.08 13.2001H9.76875C8.98875 13.5751 8.1225 13.8001 7.2 13.8001C6.2775 13.8001 5.415 13.5751 4.63125 13.2001H4.32C1.935 13.2001 0 15.1351 0 17.5201V18.6001C0 19.5938 0.80625 20.4001 1.8 20.4001H12.6C13.5938 20.4001 14.4 19.5938 14.4 18.6001V17.5201C14.4 15.1351 12.465 13.2001 10.08 13.2001ZM18 12.0001C19.9875 12.0001 21.6 10.3876 21.6 8.4001C21.6 6.4126 19.9875 4.8001 18 4.8001C16.0125 4.8001 14.4 6.4126 14.4 8.4001C14.4 10.3876 16.0125 12.0001 18 12.0001ZM19.8 13.2001H19.6575C19.1363 13.3801 18.585 13.5001 18 13.5001C17.415 13.5001 16.8638 13.3801 16.3425 13.2001H16.2C15.435 13.2001 14.73 13.4213 14.1112 13.7776C15.0262 14.7638 15.6 16.0726 15.6 17.5201V18.9601C15.6 19.0426 15.5813 19.1213 15.5775 19.2001H22.2C23.1938 19.2001 24 18.3938 24 17.4001C24 15.0788 22.1213 13.2001 19.8 13.2001Z",
    fill: "#2A2A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendsLogo);
export default __webpack_public_path__ + "static/media/friendsLogo.25128456c03657bea69927ac6cdf60b6.svg";
export { ForwardRef as ReactComponent };